import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { WrapLocation } from 'types/HistoryTypes';

export const useWrapLocation = (): WrapLocation => {
    const location = useLocation();

    return useMemo(() => {
        const params = new URLSearchParams(location?.search);
        const query: Record<string, string> = {};
        params.forEach((value, key) => {
            query[key] = value;
        });
        return {
            ...location,
            query,
        };
    }, [location?.search, location?.pathname]);
};
